import React, { FC, useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  makeStyles,
  Tooltip
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CloseIcon from '@material-ui/icons/Close';
import LinkIcon from '@material-ui/icons/Link';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import useQuotationProduct from 'src/hooks/quotation-v2/use-quotation-products';
import { copyToClipboard } from 'src/utils';
import { Quotation } from 'src/types';

const useStyles = makeStyles(() => ({
  menuButton: {
    padding: 4
  },
  menuItemContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  }
}));

interface Props {
  index: number;
  quotation: Quotation;
}

const ComponentMenu: FC<Props> = ({ index, quotation }) => {
  const classes = useStyles();
  const { quotationData, onRemoveQuotation } = useQuotationProduct();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onHandleCopyProductName = (product?: string) => {
    copyToClipboard(product || '');
  };

  const onHandleNavigateProduct = (product_id?: number) => {
    if (product_id) {
      window.open(
        `/app/products/${product_id}`,
        '_blank',
        'noopener,noreferrer'
      );
    }
  };

  return (
    <>
      <IconButton
        className={classes.menuButton}
        aria-controls="component-menu"
        aria-haspopup="true"
        onClick={handleOpen}
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        id="component-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            onHandleCopyProductName(quotation?.product?.product_name);
            handleClose();
          }}
        >
          <div className={classes.menuItemContent}>
            <Tooltip title="Copy product name">
              <IconButton size="small">
                <FileCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        </MenuItem>

        <MenuItem
          onClick={() => {
            onHandleNavigateProduct(quotation?.product?.product_id);
            handleClose();
          }}
        >
          <div className={classes.menuItemContent}>
            <Tooltip title="Navigate to product">
              <IconButton size="small">
                <LinkIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        </MenuItem>

        <MenuItem
          onClick={() => {
            onRemoveQuotation(index, quotationData);
            handleClose();
          }}
        >
          <div className={classes.menuItemContent}>
            <Tooltip title="Remove row component">
              <IconButton size="small">
                <CloseIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        </MenuItem>
      </Menu>
    </>
  );
};

export default ComponentMenu;
